// @flow
import React from 'react';
import CardCarousel from '@homeaway/react-card-carousel';
import PropertyCard from './PropertyCard/PropertyCard';
import type {PropertyCardListingShape} from './PropertyCard/PropertyCard';

import './PropertyCarousel.less';

type Props = {
    cardIndex?: number,
    isMobile: boolean,
    title: string,
    breakpoints: Object,
    listings: PropertyCardListingShape[],
    onCarouselResize?: Function,
    seeMoreUrl?: string,
    withTripboardButton: boolean,
    withImagesCarousel: boolean,
    onCardClick: Function,
    onCardEnter: Function
};

const renderCards = (
    listings,
    isMobile,
    seeMoreUrl,
    withTripboardButton,
    withImagesCarousel,
    onCardClick,
    onCardEnter
) => {
    return listings.map((listing) => (
        <PropertyCard
            listing={listing}
            isMobile={isMobile}
            key={listing.listingId}
            seeMoreUrl={seeMoreUrl}
            withTripboardButton={withTripboardButton}
            withImagesCarousel={withImagesCarousel}
            onCardClick={onCardClick}
            onCardEnter={onCardEnter}
        />
    ));
};

export const PropertyCarousel = (props: Props) => {
    const {
        cardIndex,
        isMobile,
        title,
        breakpoints,
        onCarouselResize,
        onCardClick,
        onCardEnter,
        listings,
        seeMoreUrl,
        withTripboardButton,
        withImagesCarousel
    } = props;

    return (
        <CardCarousel
            breakpoints={breakpoints}
            scrolling={isMobile}
            title={title}
            cardIndex={cardIndex ? cardIndex : 0}
            onResize={
                onCarouselResize
                    ? onCarouselResize
                    : /* istanbul ignore next */ () => {}
            }
        >
            {renderCards(
                listings,
                isMobile,
                seeMoreUrl,
                withTripboardButton,
                withImagesCarousel,
                onCardClick,
                onCardEnter
            )}
        </CardCarousel>
    );
};

PropertyCarousel.defaultProps = {
    withTripboardButton: false,
    withImagesCarousel: false
};

export default PropertyCarousel;
